"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var AlertGrid = _styledComponents.default.div.withConfig({
  displayName: "PromotionBanner__AlertGrid",
  componentId: "sc-1kbztyt-0"
})(["display:grid;grid-template-columns:1fr auto;align-items:center;@media (max-width:767px){grid-template-columns:1fr;grid-template-rows:1fr auto;}"]);

var AlertTitle = _styledComponents.default.h5.withConfig({
  displayName: "PromotionBanner__AlertTitle",
  componentId: "sc-1kbztyt-1"
})(["font-weight:700;margin-right:20px;display:inline-block;margin-bottom:0;"]);

var AlertDescription = _styledComponents.default.div.withConfig({
  displayName: "PromotionBanner__AlertDescription",
  componentId: "sc-1kbztyt-2"
})(["display:inline-block;margin-top:4px;"]);

var PromotionBanner = function PromotionBanner(_ref) {
  var promotion = _ref.promotion,
      title = _ref.title,
      description = _ref.description,
      cta = _ref.cta,
      dataSelenium = _ref.dataSelenium,
      _ref$shouldShow = _ref.shouldShow,
      shouldShow = _ref$shouldShow === void 0 ? true : _ref$shouldShow,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["promotion", "title", "description", "cta", "dataSelenium", "shouldShow"]);
  (0, _react.useEffect)(function () {
    if (shouldShow) {
      var name = promotion.toLowerCase() + " promotion banner";
      (0, _getUsageTracker.default)().track('bannerInteraction', {
        name: name
      });
    }
  }, []);
  return shouldShow && _react.default.createElement(_UIAlert.default, Object.assign({
    "data-selenium": dataSelenium,
    type: "info"
  }, rest), _react.default.createElement(AlertGrid, {
    style: cta ? {
      gridColumnGap: '16px',
      gridRowGap: '16px'
    } : {}
  }, _react.default.createElement("div", null, _react.default.createElement(AlertTitle, null, title), _react.default.createElement(AlertDescription, null, description)), cta && _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
    href: cta.url,
    use: "tertiary",
    size: "small",
    style: {
      width: '100%'
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    message: cta.message
  })))));
};

PromotionBanner.propTypes = {
  promotion: _propTypes.default.string.isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  cta: _propTypes.default.shape({
    message: _propTypes.default.string,
    url: _propTypes.default.string
  }),
  dataSelenium: _propTypes.default.string,
  shouldShow: _propTypes.default.bool
};
var _default = PromotionBanner;
exports.default = _default;
module.exports = exports.default;